import { render, staticRenderFns } from "./group.vue?vue&type=template&id=2f90a4fe&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=2f90a4fe&prod&lang=scss&scoped=true"
import style1 from "./group.vue?vue&type=style&index=1&id=2f90a4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90a4fe",
  null
  
)

export default component.exports